import { AvatarFallback, AvatarImage, Avatar as InternalAvatar } from '@bpinternal/ui-kit-next'
import { ComponentProps } from 'react'
import { Color } from '../types/colors'
import { cn, hashIdToColor } from '../utils'

type Props = {
  pictureUrl?: string
  name?: string
  color?: Color | 'auto'
  variant?: 'solid' | 'soft'
} & ComponentProps<typeof InternalAvatar>

const getVariantClassName = (variant: 'solid' | 'soft', color: Color) => {
  return { soft: `bg-${color}-100 text-${color}-700`, solid: `bg-${color}-500 text-white` }[variant]
}

export const Avatar = ({ ref, pictureUrl, name, className, color = 'auto', variant = 'soft', ...props }: Props) => {
  const firstLetter = name?.[0]?.toUpperCase() ?? '?'
  const avatarColor = color === 'auto' ? hashIdToColor(name ?? '', 'regular') : color
  const variantClassName = getVariantClassName(variant, avatarColor)

  return (
    <InternalAvatar className={className} ref={ref} {...props}>
      <AvatarImage src={pictureUrl} />
      <AvatarFallback className={cn(className, variantClassName)}>{firstLetter}</AvatarFallback>
    </InternalAvatar>
  )
}

Avatar.displayName = 'Avatar'
